import { AmplitudeFlagType, TruthyValuesForFlagKeys } from './amplitudeFlags';
import useExperiment from './useExperiment';

const useIsExperimentActive = (experimentName: AmplitudeFlagType): boolean => {
  const experiment = useExperiment();
  const truthyExperimentValue = TruthyValuesForFlagKeys[experimentName];

  if (!truthyExperimentValue) {
    throw new Error(
      'you need to provide truthy value for your Experiment name flag key, check "types/amplitudeFlags.ts"'
    );
  }

  return experiment.isVariantActive(experimentName, truthyExperimentValue);
};

export default useIsExperimentActive;
